import React, { useState, useEffect, useRef } from 'react';
import aselaImg from '../../Assets/Mr_Asela.jpg';
import sanjeewaImg from '../../Assets/Mr_Sanjeewa.jpg';
import './About_Us.css';

const About_Us = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [cardsToShow, setCardsToShow] = useState(3);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);
    const carouselRef = useRef(null);
   
    const partners = [
        {
            name: 'Mr. Asela Mudannayake',
            position: 'Partner',
            description: 'Mr. Asela Mudannayake holds a BSc in Accounting (Special), is a Fellow Chartered Accountant (FCA), and has a Diploma in ERP systems.',
            img: aselaImg
        },
        {
            name: 'Mr. Pradeep Sanjeewa',
            position: 'Partner',
            description: 'Mr. Pradeep Sanjeewa is a Chartered professional specializing as a Tax Advisor. He holds certifications including CBA and SAT, bringing expert knowledge in tax consultancy and financial advisory to support our clients\' growth and compliance needs.',
            img: sanjeewaImg
        },
        {
            name: 'Mr. Kalinga',
            position: 'Partner',
            description: '',
            
        },
        
    ];

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setCardsToShow(1);
            } else if (window.innerWidth <= 1024) {
                setCardsToShow(2);
            } else {
                setCardsToShow(3);
            }
            setCurrentIndex(0);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handlePrev = () => {
        setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
    };

    const handleNext = () => {
        setCurrentIndex((prev) => (prev < partners.length - cardsToShow ? prev + 1 : prev));
    };

    // Touch handlers for swipe functionality
    const handleTouchStart = (e) => {
        setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > 50;
        const isRightSwipe = distance < -50;

        if (isLeftSwipe && currentIndex < partners.length - cardsToShow) {
            handleNext();
        }

        if (isRightSwipe && currentIndex > 0) {
            handlePrev();
        }

        setTouchStart(0);
        setTouchEnd(0);
    };

    const openModal = (partner) => {
        setSelectedPartner(partner);
    };

    const closeModal = () => {
        setSelectedPartner(null);
    };

    const showArrows = partners.length > cardsToShow;

    return (
        <div className="about-us-container">
            <div className="content-wrapper">
                <div className="header-section">
                    <h1 className="main-title">About Us</h1>
                    <p className="intro-text">
                        VTAS Associates is an independent firm of Chartered Accountants in Sri Lanka. Our motivated workforce with high integrity, sincerity, and professionalism are dedicated to deliver high-quality services to meet our valued clients' requirements.
                    </p>
                    <div className="vision-mission-container">
                        <div className="vision-mission-item vision-item">
                            <h2>Our Vision</h2>
                            <p>
                                To be the most trusted and preferred Chartered Accounting firm in Sri Lanka, recognized for our ethical practices, innovative solutions, and exceptional client service. We aim to empower businesses to achieve sustainable growth and financial stability.
                            </p>
                        </div>

                        <div className="vision-mission-item mission-item">
                            <h2>Our Mission</h2>
                            <p>
                                To provide comprehensive, high-quality, and timely financial and advisory services that help our clients navigate complex business challenges and capitalize on opportunities. We are committed to building long-term relationships based on trust, integrity, and mutual respect, while fostering a culture of continuous learning and professional excellence within our team.
                            </p>
                        </div>
                    </div>
                </div>
           
                <hr className="horizontal-line" />

                <section className="partners-section">
                    <h1 className="partners-title">Our Partners</h1>
                    
                    <div className="carousel-wrapper">
                        {showArrows && currentIndex > 0 && (
                            <button
                                onClick={handlePrev}
                                className="carousel-arrow arrow-left"
                            >
                                ‹
                            </button>
                        )}

                        <div 
                            className="carousel-container"
                            ref={carouselRef}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        >
                            <div
                                className="carousel-track"
                                style={{
                                    transform: `translateX(-${currentIndex * (100 / cardsToShow)}%)`
                                }}
                            >
                                {partners.map((partner, index) => (
                                    <div
                                        key={index}
                                        className="partner-card-wrapper"
                                        style={{
                                            flex: `0 0 ${100 / cardsToShow}%`
                                        }}
                                    >
                                        <div
                                            onClick={() => openModal(partner)}
                                            className="partner-card"
                                        >
                                            <img
                                                src={partner.img}
                                                alt={partner.name}
                                                className="partner-image"
                                            />
                                            <div className="partner-overlay">
                                                Click for details
                                            </div>
                                        </div>
                                        <div className="partner-info">
                                            <h2 className="partner-name">
                                                {partner.name}
                                            </h2>
                                            <h4 className="partner-position">
                                                {partner.position}
                                            </h4>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {showArrows && currentIndex < partners.length - cardsToShow && (
                            <button
                                onClick={handleNext}
                                className="carousel-arrow arrow-right"
                            >
                                ›
                            </button>
                        )}
                    </div>

                    <div className="carousel-indicators">
                        {Array.from({ length: partners.length - cardsToShow + 1 }).map((_, idx) => (
                            <button
                                key={idx}
                                onClick={() => setCurrentIndex(idx)}
                                className={`indicator-dot ${currentIndex === idx ? 'active' : ''}`}
                            />
                        ))}
                    </div>
                </section>
            </div>

            {selectedPartner && (
                <div
                    onClick={closeModal}
                    className="modal-overlay"
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="modal-content"
                    >
                        <button
                            onClick={closeModal}
                            className="modal-close"
                        >
                            ×
                        </button>
                        <div className="modal-body">
                            <h2 className="modal-name">
                                {selectedPartner.name}
                            </h2>
                            <h4 className="modal-position">
                                {selectedPartner.position}
                            </h4>
                            <p className="modal-description">
                                {selectedPartner.description}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default About_Us;